/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TicketTypeParam { 
    /**
     * Id Hash. UTTI (Unique Ticket Type Identifier). Maximum lenght 88. Mandatory in the PUT Service. Must not be specified in the POST Service. Optional in the GET Service.
     */
    idHash?: string;
    /**
     * Id Hash. UEI (Unique Event Identifier). Maximum lenght 88. Mandatory in the POST and PUT Services. Optional in the GET Service.
     */
    idHashEvent?: string;
    /**
     * Name. Maximum lenght 255
     */
    name: string;
    /**
     * Description
     */
    description?: string;
    /**
     * Fiat price
     */
    fiatPrice?: number;
    /**
     * Crypto price
     */
    cryptoPrice?: number;
    /**
     * Total Amount
     */
    totalAmount?: number;
    /**
     * Selling amount
     */
    sellingAmount?: number;
    /**
     * Maximum amount per user
     */
    maximumAmountPerUser?: number;
    /**
     * Allowed resale
     */
    allowedResale?: boolean;
    /**
     * Resale rate
     */
    resaleRate?: number;
    /**
     * Minimum resale fiat price
     */
    minimumResaleFiatPrice?: number;
    /**
     * Maximum resale fiat price
     */
    maximumResaleFiatPrice?: number;
    /**
     * Minimum resale fiat price
     */
    minimumResaleCryptoPrice?: number;
    /**
     * Maximum resale crypto price
     */
    maximumResaleCryptoPrice?: number;
    /**
     * Featured image
     */
    featuredImage?: string;
}

